module.exports = __webpack_public_path__ + "static/img/shiziwan2.4647bbf3.png";